import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    const savedState = localStorage.getItem('sidebarState')
    const columns = this.element.closest('.l-columns')
    if (!columns) return

    if (savedState === 'collapsed') {
      columns.classList.add('is-sidebar-collapsed')
    } else {
      columns.classList.remove('is-sidebar-collapsed')
    }
  }

  toggle() {
    const columns = this.element.closest('.l-columns')
    if (!columns) return
    
    if (columns.classList.contains('is-sidebar-collapsed')) {
      this.openSidebar()
    } else {
      this.closeSidebar()
    }
  }

  openSidebar() {
    const columns = this.element.closest('.l-columns')
    if (!columns) return

    columns.classList.remove('is-sidebar-collapsed')
    localStorage.setItem('sidebarState', 'expanded')
  }

  closeSidebar() {
    const columns = this.element.closest('.l-columns')
    if (!columns) return

    columns.classList.add('is-sidebar-collapsed')
    localStorage.setItem('sidebarState', 'collapsed')
  }

}
